



import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getLogos,
  getIcons,

  
} from "../../components/Constant/Constant";


import { productName , clientCompanyName} from "../../config/clientsConfig";
import NotificationService from "../../components/Services/NotificationService";
import { listenForMessages, requestFCMToken } from "../../firebase/messaging";
import { isManagement, userUid } from "../../utils/storage";
import { showInfoToast } from "../../components/Constant/Notification";
import GeoImages from "../Constant/GeoImages";
import UserNavigationSystem from "../../GLFunnelDashboardComponents/UserNavigationSystem";
import useUserStatusCheck from "../../hooks/useUserStatusCheck";

const NavItem = ({ icon, activeIcon, isActive, label, onClick }) => (
  <div
    className="flex flex-col justify-center items-center gap-1.5 cursor-pointer transition-all duration-200 hover:opacity-80"
    onClick={onClick}
  >
    <div className="p-2 rounded-full bg-opacity-10 hover:bg-gray-100">
      <img
        className="w-6 h-6 md:w-7 md:h-7 lg:w-7 lg:h-7 xl:w-7 xl:h-7 2xl:w-8 2xl:h-8"
        src={isActive ? activeIcon : icon}
        alt={`${label} icon`}
      />
    </div>
    <span className={`font-medium text-sm ${isActive ? "text-customGreen" : "text-gray-700"}`}>
      {label}
    </span>
  </div>
);


const Header = ({isMenu = true}) => {
  const [activeRoute, setActiveRoute] = useState("");
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const logos = getLogos();
  const icons = getIcons();
  const location = useLocation();
  const navigate = useNavigate();
  

  const userData = JSON.parse(localStorage.getItem("userData") || "{}");
  const userRole = userData?.user?.role || "";
  const userName = userData?.user?.name || "";
  
  useEffect(() => {
    const path = location.pathname;
    if (path.includes("/geo-location-dashboard")) setActiveRoute("dashboard");
    // else if (path.includes("/geo-location-analytics")) setActiveRoute("analytics");
    else if (path.includes("/geo-location-live-tracking")) setActiveRoute("live-tracking");
    else if (path.includes("/geo-location-report")) setActiveRoute("report");
    // else if (path.includes("/geo-location-setup")) setActiveRoute("setup");
  
  }, [location.pathname]);

  // useEffect(() => {
  //   const initializeNotifications = async () => {
  //     try {
  //       const token = await requestFCMToken();
  
  //       console.log("FCM Token:", token);
  
        
  //       if (token) {
  //         const body = {
  //           token: token,
  //           uid: userUid,
  //         };
  
  //         await NotificationService.postTokenUserDevice(body);
  //       }
  
  //       listenForMessages((payload) => {
  //         const { title, body } = payload.notification;
  //         showInfoToast(`${title}\n${body}`);
  //       });
  //     } catch (error) {
  //       console.error("Notification setup failed:", error);
  //     }
  //   };
  
  //   initializeNotifications();
  // }, []);

 
  const handleNavigation = (path) => {
    // const baseRole = {
    //   "Admin": "/admin",
    //   "CMO": "/cmo",
    //   "MD": "/md",
    //   "BOD": "/bod"
    // }[userRole] || "";
    
    navigate(`${path}`);
  };

  const handleSignout = () => {
    localStorage.clear();
    navigate("/");
    window.location.reload();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(".profile-menu-container")) {
        setIsProfileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const navItems = [
    {
      id: "dashboard",
      label: "Dashboard",
      icon: GeoImages.dashboardIcon,
      activeIcon: GeoImages.dashboardActiveIcon,
      path: "/geo-location-dashboard",
      visible: true
    },
    // {
    //   id: "analytics",
    //   label: "Employee Analytics",
    //   icon: GeoImages.analyticsIcon,
    //   activeIcon: GeoImages.analyticsActiveIcon,
    //   path: "/geo-location-analytics",
    //   visible: true
    // },
    {
      id: "live-tracking",
      label: "Live Tracking",
      icon: GeoImages.geoLocationIcon,
      activeIcon: GeoImages.geoLocationActiveIcon,
      path: "/geo-location-live-tracking",
      visible: true
    },
    {
      id: "report",
      label: "Report",
      icon: GeoImages.reportIcon,
      activeIcon: GeoImages.reportAtiveIcon,
      path: "/geo-location-report",
      visible: true
    },
    // {
    //   id: "setup",
    //   label: "Setup",
    //   icon: icons.setupIcon,
    //   activeIcon: icons.setupIconActive,
    //   path: "/geo-location-setup",
    //   visible: userRole === "Admin" || userRole === "CMO"
    // }
  ];

   useUserStatusCheck();

  return (
    <nav className="w-full h-16 md:h-18 lg:h-20 fixed z-20 top-0 flex items-center justify-between px-6 shadow-md bg-white">
      {/* Logo section */}
      <div
        className="flex items-center cursor-pointer"
        // onClick={() => handleNavigation("/dashboard")}
      >
        <img
          className="w-8 h-8 md:w-9 md:h-9 lg:w-10 lg:h-10 2xl:w-12 2xl:h-12"
          src={logos.glFunnelLogo}
          alt="Company Logo"
        />
        <span className="ml-2 text-xl md:text-2xl lg:text-2xl 2xl:text-3xl font-semibold text-customGreen">
          {productName}
        </span>
      </div>

      {/* Navigation Items */}
{isMenu &&      <div className="flex items-center gap-4 md:gap-6 lg:gap-8 xl:gap-10 2xl:gap-12 justify-center">
        {navItems.filter(item => item.visible).map(item => (
          <NavItem
            key={item.id}
            icon={item.icon}
            activeIcon={item.activeIcon}
            isActive={activeRoute === item.id}
            label={item.label}
            onClick={() => handleNavigation(item.path)}
          />
        ))}
      </div>}

      {/* User Profile */}
      <div className="flex items-center">
        {/* <div className="mr-4">
          <FBLogin />
        </div> */}
        
        <div className="profile-menu-container relative">
          <div 
            className="flex items-center cursor-pointer" 
            onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
          >
            <div className="text-right mr-2">
              <div className="font-bold text-base lg:text-lg">Hi, {userName}</div>
              <div className="text-sm lg:text-base text-gray-600">{clientCompanyName}</div>
            </div>
            
            <div className="flex-shrink-0">
              <img
                className="w-10 h-10 lg:w-12 lg:h-12 rounded-full border-2 border-gray-200"
                src={logos.clientLogo}
                alt="Client Logo"
              />
              <div className="absolute bottom-0 right-0 w-3 h-3 bg-green-500 rounded-full border border-white"></div>
            </div>
          </div>

          {/* Profile dropdown menu */}
        {isManagement ? (
                 <>
                  {isProfileMenuOpen && (
                 <UserNavigationSystem isOpen={isProfileMenuOpen} onClose={() => setIsProfileMenuOpen(false)} profilePath={`/geo-location-my-profile`} />
                )}
                 </>
               
               ):(
                 <>
                 
                 {isProfileMenuOpen && (
                           <div className="absolute right-0 mt-5 w-48 bg-white rounded-lg shadow-lg py-1 z-50">
                             <div className="px-4 py-2 border-b border-gray-100">
                               <p className="text-sm font-medium text-gray-900">{userName}</p>
                               <p className="text-xs text-gray-500">{userRole}</p>
                             </div>
                             <button
                               className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                               onClick={() => {
                                 handleNavigation("/geo-location-my-profile");
                                 setIsProfileMenuOpen(false);
                               }}
                             >
                               Profile
                             </button>
                             <button
                               className="block w-full text-left px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                               onClick={() => {
                                 handleSignout();
                                 setIsProfileMenuOpen(false);
                               }}
                             >
                               Sign Out
                             </button>
                           </div>
                         )}
                 </>
               )}
        </div>
      </div>
    </nav>
  );
};

export default Header;